module.exports = __webpack_public_path__ + "assets/next-white.svg?ver=dc284f13";